import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';

interface Props {
  srce: string;
  onCropComplete: (croppedImage: string) => void;
  uploadError?: string;
}

const ImageCropper: React.FC<Props> = ({
  srce,
  onCropComplete,
  uploadError,
}) => {
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);

  const onCropChange = useCallback((crop: { x: number; y: number }) => {
    setCrop(crop);
  }, []);

  const onZoomChange = useCallback((zoom: number) => {
    setZoom(zoom);
  }, []);

  const onCropCompleted = useCallback(
    (croppedArea: any, croppedAreaPixels: any) => {
      setCroppedAreaPixels(croppedAreaPixels);
    },
    [],
  );

  const getCroppedImage = useCallback(() => {
    if (!croppedAreaPixels) {
      return;
    }

    const image = new Image();
    image.src = srce;

    const canvas = document.createElement('canvas');
    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
      );

      const croppedImage = canvas.toDataURL('image/png');
      onCropComplete(croppedImage);
    }
  }, [croppedAreaPixels, onCropComplete, srce]);

  return (
    <div className="crop_img_container">
      <div className="crop_imag_frame">
        <Cropper
          image={srce}
          crop={crop}
          zoom={zoom}
          aspect={1 / 1}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          onCropComplete={onCropCompleted}
        />
      </div>
      <div className="crop_imag_uploadbtn">
        <button onClick={getCroppedImage} className="upload_btn">
          Upload Image
        </button>
        {uploadError && (
          <p className="text-danger uploder_error">{uploadError}</p>
        )}
      </div>
    </div>
  );
};

const MemoizedComponent = React.memo(ImageCropper);
export default MemoizedComponent;
